var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory, SurveyElementBase, Survey } from "survey-react-ui";
import { SurfacePlaceholder } from "../../components/SurfacePlaceholder";
var TabTranslationComponent = /** @class */ (function (_super) {
    __extends(TabTranslationComponent, _super);
    function TabTranslationComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TabTranslationComponent.prototype, "model", {
        get: function () {
            return this.props.data || this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    TabTranslationComponent.prototype.getStateElement = function () {
        return this.model;
    };
    TabTranslationComponent.prototype.renderElement = function () {
        if (!this.model)
            return null;
        return (React.createElement("div", { className: "svc-creator-tab__content svc-translation-tab" + (this.model.isEmpty ? " svc-translation-tab--empty" : "") }, this.renderElementContent()));
    };
    TabTranslationComponent.prototype.renderElementContent = function () {
        if (this.model.isEmpty) {
            return React.createElement(SurfacePlaceholder, { name: "translation", placeholderTitleText: this.model.placeholderTitleText, placeholderDescriptionText: this.model.placeholderDescriptionText });
        }
        else {
            return (React.createElement("div", { className: "st-content" },
                React.createElement("div", { className: "svc-flex-column st-strings-wrapper" },
                    React.createElement("div", { className: "svc-flex-row st-strings-header" },
                        React.createElement(Survey, { model: this.model.stringsHeaderSurvey })),
                    React.createElement("div", { className: "svc-flex-row svc-plugin-tab__content st-strings" },
                        React.createElement(Survey, { model: this.model.stringsSurvey })))));
        }
    };
    return TabTranslationComponent;
}(SurveyElementBase));
export { TabTranslationComponent };
ReactElementFactory.Instance.registerElement("svc-tab-translation", function (props) {
    return React.createElement(TabTranslationComponent, props);
});
